import { render, staticRenderFns } from "./FeedProductName.vue?vue&type=template&id=4c633d0f&"
import script from "./FeedProductName.vue?vue&type=script&lang=ts&"
export * from "./FeedProductName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports